import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SubscriptionDialogComponent } from "../subscription-dialog/subscription-dialog.component";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { CommonService } from "../shared/service/common.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    public db: AngularFirestore,
    public auth: AngularFireAuth,
    public router: Router,
    public dialog: MatDialog,
    private analytics: AngularFireAnalytics,
    public common: CommonService
  ) {
    this.auth.authState.subscribe((res) => {
      if (this.getAuthStatus()) {
        let uid: any = localStorage.getItem("uid");
        this.db
          .collection("Parents")
          .doc(uid)
          .valueChanges()
          .subscribe((res: any) => {
            let freeTrialValidity = res?.created_at?.toDate();
            if (!freeTrialValidity) {
              freeTrialValidity = new Date();
            }
            freeTrialValidity.setDate(freeTrialValidity.getDate() + 35);
            if (freeTrialValidity < new Date()) {
              if (res?.subscription_status != "completed") {
                this.openDialog();
              } else {
                this.dialog.closeAll();
              }
            } else {
              this.dialog.closeAll();
            }
          });
      }
    });
  }

  signin(email: string, password: string) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  async register(data: any) {
    try {
      let user = await this.auth.createUserWithEmailAndPassword(
        data.email,
        data.password
      );
      delete data.password;
      await this.db.collection("Parents").doc(user.user?.uid).set(data);
      await this.analytics.logEvent("sign_up");
      return user;
    } catch (err) {
      //  console.log(err);
      this.common.showError("Email Already in use");
    }
  }

  async getUserData(uid: any) {
    return this.db.collection("Parents").doc(uid).get().toPromise();
  }

  getUserId() {
    let uid: any = localStorage.getItem("uid");
    return uid;
  }

  async logout() {
    this.common.showLoader();
    try {
      await this.auth.signOut();
      localStorage.clear();
      window.location.reload();
      this.common.showSuccess("Logout successfull");
      this.common.hideLoader();
    } catch (err) {
      this.common.hideLoader();
      this.common.showError("Logout Failed");
    }
  }
  getAuthStatus() {
    if (localStorage.getItem("uid")) {
      return true;
    } else {
      return false;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(SubscriptionDialogComponent, {
      disableClose: true,
    });
  }
}
